import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

/**
 * Store to track hasHelp state for problems to avoid UI flash when switching
 * between problems. This store persists the currently displayed hasHelp state
 * so the button doesn't flash from "Show Steps" to "Show Answer" and back to
 * "Show Steps" while the new problem JSON is loading.
 *
 * When switching problems, the button continues showing the previous state until
 * the new problem's data loads, then updates once.
 */

export interface NeedHelpButtonStoreState {
  // The currently displayed hasHelp state (what the button is showing right now)
  currentDisplayedHasHelp: boolean;
}

export interface NeedHelpButtonStore extends NeedHelpButtonStoreState {
  setCurrentDisplayedHasHelp: (hasHelp: boolean) => void;
}

export const needHelpButtonStore = create<NeedHelpButtonStore>()(
  devtools(
    immer(set => ({
      currentDisplayedHasHelp: false,

      setCurrentDisplayedHasHelp: (hasHelp: boolean) => {
        set(state => {
          state.currentDisplayedHasHelp = hasHelp;
        });
      },
    })),
    { name: 'NeedHelpButtonStore' }
  )
);
